import { r as registerInstance, h, H as Host, g as getElement } from './index-d4808923.js';
import { b as bem, g as global$1 } from './index.esm-7182addc.js';
import { g as gravityXSSWhitelist, l as lib, x as xss } from './gravity-xss-whitelist-53c2079f.js';
import { c as createPopper } from './popper-1604923e.js';

const gravityFormFieldCss = ".gravity-form-field{display:flex;flex-direction:column;width:100%}.gravity-form-field--size-small{gap:4px}.gravity-form-field--size-medium{gap:6px}.gravity-form-field--inline{flex-direction:row;gap:12px}.gravity-form-field__label-container{display:flex;flex:1 0 auto}.gravity-form-field__label-container:empty{display:none}.gravity-form-field__label-container--inline{align-items:center;gap:4px}.gravity-form-field__label-container--inline.gravity-form-field__label-container--size-medium{height:40px}.gravity-form-field__label-container--inline.gravity-form-field__label-container--size-small{height:32px}.gravity-form-field__label-container-inner{align-items:flex-start;display:flex;gap:4px;justify-content:space-between;max-height:100%;width:100%}.gravity-form-field__label-container-inner--info-inline{justify-content:left}.gravity-form-field__label{position:relative}.gravity-form-field__label-asterisk{color:#DB0A40;margin-left:4px}.gravity-form-field__label-highlighted{background-image:url(\"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNSIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDUgMTYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTAgNkMwIDQuNjE5MjkgMS4xMTkyOSAzLjUgMi41IDMuNUMzLjg4MDcxIDMuNSA1IDQuNjE5MjkgNSA2QzUgNy4zODA3MSAzLjg4MDcxIDguNSAyLjUgOC41QzEuMTE5MjkgOC41IDAgNy4zODA3MSAwIDZaIiBmaWxsPSIjMUI2QUVFIi8+PC9zdmc+\");background-repeat:no-repeat;background-size:cover;display:inline-block;height:1em;margin-left:8px;margin-top:-2px;width:5px;margin-left:4px}.gravity-form-field__input-container{display:flex;flex-direction:column;gap:8px;width:100%}.gravity-form-field__input-container--inline{flex-grow:1}.gravity-form-field__input-container--size-small{gap:4px}.gravity-form-field__input-container--size-medium{gap:6px}.gravity-form-field__error,.gravity-form-field__info{align-items:flex-start;display:flex;gap:4px}.gravity-form-field__error-icon,.gravity-form-field__info-icon{display:flex}";
const GravityFormFieldStyle0 = gravityFormFieldCss;

const GravityFormField = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.generateClassNames = bem('gravity-form-field');
        this.xssOptions = {
            whiteList: Object.assign(Object.assign({}, gravityXSSWhitelist), lib.exports.whiteList),
        };
        this.disabled = false;
        this.highlighted = false;
        this.infoBottom = false;
        this.infoInline = false;
        this.infoPosition = 'top';
        this.infoText = '';
        this.infoWidth = undefined;
        this.inline = false;
        this.inlineLabelWidth = '33%';
        this.invalid = false;
        this.label = '';
        this.required = false;
        this.size = 'medium';
        this.validationMessage = undefined;
        this.valueMissing = false;
    }
    renderLabel() {
        const labelText = this.renderLabelText();
        const labelInfo = this.renderLabelInfo();
        if (!labelText && !labelInfo) {
            return;
        }
        return (h("div", { class: this.generateClassNames('label-container-inner', {
                'info-inline': this.infoInline,
            }) }, labelText, labelInfo));
    }
    renderLabelText() {
        if (!this.label) {
            return;
        }
        return (h("gravity-text", { size: "xx-small", class: this.generateClassNames('label'), color: this.disabled ? 'dark-muted' : 'dark-subtle', weight: "medium" }, this.label, this.required && h("span", { class: this.generateClassNames('label-asterisk') }, "*"), this.highlighted && h("span", { class: this.generateClassNames('label-highlighted') })));
    }
    renderLabelInfo() {
        if (this.infoBottom || !this.infoText) {
            return;
        }
        return [
            h("gravity-icon", { id: "info-icon", class: this.generateClassNames('info-icon'), color: "dark", name: "info-multicolor", size: "xxx-small" }),
            h("gravity-tooltip", { for: "info-icon", position: this.infoPosition, "stay-on-hover": "true" }, h("div", { style: { width: this.infoWidth } }, h("gravity-text", { innerHTML: xss(this.infoText, this.xssOptions) }))),
        ];
    }
    renderBottomInfo() {
        if (!this.infoBottom || !this.infoText || (this.invalid && this.validationMessage)) {
            return;
        }
        return (h("div", { class: this.generateClassNames('info') }, h("gravity-icon", { class: this.generateClassNames('info-icon'), color: "dark", name: "info-multicolor", size: "tiny" }), h("gravity-text", { key: 'info-message', color: "dark-subtle", size: "xx-small", weight: "medium", innerHTML: xss(this.infoText, this.xssOptions) })));
    }
    renderValidationMessage() {
        if (!this.validationMessage || !this.invalid) {
            return;
        }
        return (h("div", { class: this.generateClassNames('error') }, h("gravity-icon", { class: this.generateClassNames('error-icon'), color: "negative", name: "warning-outline", size: "tiny" }), h("gravity-text", { class: this.generateClassNames('error-text'), key: 'error-message', color: "negative", size: "xx-small", weight: "medium" }, this.validationMessage)));
    }
    render() {
        return (h(Host, { key: '09d0ab930cc75666e78c69b9a4484fbe3756a244' }, h("div", { key: '25c736d934f1d25b6f7f07f6c44a3fc0358954f0', class: this.generateClassNames({
                size: this.size,
                inline: this.inline,
                disabled: this.disabled,
                valueMissing: this.valueMissing,
                highlighted: this.highlighted,
            }) }, h("div", { key: 'dac9564905cdb0bfa73347c2f9c2615d6ee4bfc5', class: this.generateClassNames('label-container', { inline: this.inline, size: this.size }), style: { width: this.inline ? this.inlineLabelWidth : 'auto' } }, this.renderLabel()), h("div", { key: '59a1337ef827403e8b166ba8bdd61efdcd18391d', class: this.generateClassNames('input-container', { inline: this.inline, size: this.size }) }, h("slot", { key: '00a0543a919e06a16536a902f01ca059ccc1c399' }), this.renderBottomInfo(), this.renderValidationMessage()))));
    }
    get element() { return getElement(this); }
};
GravityFormField.style = GravityFormFieldStyle0;

const gravityTooltipCss = ":host{height:auto;pointer-events:none;position:fixed;z-index:2000}::slotted(gravity-text){display:block}.tooltip__arrow,.tooltip__arrow::before{background-color:#00162B;height:9px;position:absolute;width:9px}.tooltip__arrow{visibility:hidden}.tooltip__arrow::before{content:\"\";transform:rotate(45deg);visibility:visible}:host([data-popper-placement=top]) .tooltip__arrow{bottom:-4.5px}:host([data-popper-placement=top]) .tooltip__arrow::before{box-shadow:inset -1px -1px 0 0 rgba(255, 255, 255, 0.2)}:host([data-popper-placement=right]) .tooltip__arrow{left:-4.5px}:host([data-popper-placement=right]) .tooltip__arrow::before{box-shadow:inset 1px -1px 0 0 rgba(255, 255, 255, 0.2)}:host([data-popper-placement=bottom]) .tooltip__arrow{top:-4.5px}:host([data-popper-placement=bottom]) .tooltip__arrow::before{box-shadow:inset 1px 1px 0 0 rgba(255, 255, 255, 0.2)}:host([data-popper-placement=left]) .tooltip__arrow{right:-4.5px}:host([data-popper-placement=left]) .tooltip__arrow::before{box-shadow:inset -1px 1px 0 0 rgba(255, 255, 255, 0.2)}.tooltip{background-color:#00162B;border-radius:2px;box-shadow:inset 0 0 0 1px rgba(255, 255, 255, 0.2);opacity:0;outline:none;padding:4px 8px;transition:all 150ms cubic-bezier(0.32, 0, 0.32, 1);z-index:2000}.tooltip--visible{height:auto;opacity:1;pointer-events:auto;visibility:visible}.tooltip__inner{background-color:#00162B;border:1px solid #00162B}";
const GravityTooltipStyle0 = gravityTooltipCss;

const GravityTooltip = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.animationTime = 150;
        this.showDelayTime = 300;
        this.stayOnHoverTime = 100;
        this.popperInstance = undefined;
        this.isHovered = false;
        this.boundary = undefined;
        this.delay = true;
        this.flip = true;
        this.for = '';
        this.position = 'top';
        this.stayOnHover = true;
        this.visible = false;
    }
    createPopperInstance() {
        if (this.popperInstance) {
            this.popperInstance.destroy();
        }
        const boundaryElement = this.boundary && global$1.document.getElementById(this.boundary);
        const modifiers = [
            {
                name: 'offset',
                options: {
                    offset: [0, 8],
                },
            },
            {
                name: 'preventOverflow',
                options: {
                    boundary: boundaryElement || 'clippingParents',
                    rootBoundary: 'document',
                },
            },
            {
                name: 'arrow',
                options: {
                    element: this.arrowElement,
                },
            },
        ];
        if (this.flip) {
            modifiers.push({
                name: 'flip',
                options: {
                    rootBoundary: 'document',
                    boundary: boundaryElement || 'clippingParents',
                    fallbackPlacements: ['top', 'left', 'bottom', 'right'],
                    altAxis: true,
                },
            });
        }
        this.popperInstance = createPopper(this.anchorElement, this.element, {
            placement: this.position,
            strategy: 'fixed',
            modifiers,
        });
    }
    setListeners() {
        this.element.onmouseenter = () => {
            this.isHovered = true;
        };
        this.element.onmouseleave = () => {
            this.isHovered = false;
            if (this.stayOnHover) {
                this.hide();
            }
        };
        this.anchorElement.onmouseenter = () => {
            if (this.stayTimeout) {
                clearTimeout(this.stayTimeout);
            }
            this.show();
        };
        this.anchorElement.onmouseleave = () => {
            if (!this.stayOnHover) {
                this.hide();
                return;
            }
            if (this.stayTimeout) {
                clearTimeout(this.stayTimeout);
            }
            this.stayTimeout = setTimeout(() => {
                if (this.isHovered) {
                    return;
                }
                this.hide();
            }, this.stayOnHoverTime);
        };
        global$1.document.onscroll = () => {
            if (this.visible) {
                this.hide();
            }
        };
    }
    show() {
        this.createPopperInstance();
        if (this.showTimeout) {
            clearTimeout(this.showTimeout);
        }
        this.showTimeout = setTimeout(() => {
            this.visible = true;
            this.popperInstance.forceUpdate(); // it seems like if we dont force update the positioning is off
        }, this.delay ? this.showDelayTime : 0);
    }
    hide() {
        if (this.showTimeout) {
            clearTimeout(this.showTimeout);
        }
        if (this.visible) {
            setTimeout(() => {
                this.visible = false;
            }, this.animationTime);
        }
    }
    componentWillLoad() {
        var _a;
        this.anchorElement = (this.for
            ? ((_a = this.element.parentNode) === null || _a === void 0 ? void 0 : _a.querySelector(`#${this.for}`)) || this.element.parentElement
            : this.element.parentElement);
        if (!this.anchorElement) {
            console.warn(`Element #${this.for} was not found, the tooltip assigned to it will never be displayed.`);
            return;
        }
        this.setListeners();
    }
    render() {
        Array.from(this.element.querySelectorAll('gravity-text, gravity-heading')).map((el) => el.setAttribute('color', 'light'));
        return (h("div", { key: '77ca368ed4d1a21d6ef41be25fcb445156e163df', class: `tooltip ${this.visible ? 'tooltip--visible' : ''}` }, h("div", { key: 'ff0e70a322ab318e07d747fdaca74238cd76ab37', class: "tooltip__inner" }, h("slot", { key: '0ed84ae80cffc278633dc0f4ce737abe1f5304e1' }), h("div", { key: '398e49037d01d0a5aaa48417f83fae3110a030a0', ref: (el) => (this.arrowElement = el), class: "tooltip__arrow", "data-popper-arrow": true }))));
    }
    get element() { return getElement(this); }
    static get watchers() { return {
        "position": ["createPopperInstance"],
        "flip": ["createPopperInstance"],
        "boundary": ["createPopperInstance"]
    }; }
};
GravityTooltip.style = GravityTooltipStyle0;

export { GravityFormField as gravity_form_field, GravityTooltip as gravity_tooltip };

//# sourceMappingURL=gravity-form-field_2.entry.js.map